/**
 * HTML encode a string to prevent XSS attacks.
 * Used for the when the frontend is required to do the encoding, such as an optimistic response that doesn't hit the server.
 * @param {string} str - The string to encode
 * @returns {string} - The HTML encoded string
 */
export function htmlEncode(str: string): string {
    const div = document.createElement('div');
    div.textContent = str;

    return div.innerHTML;
}
